// packageTypes.js

export const PackageType = Object.freeze({
    SILVER: 1,
    GOLD: 2,
    PLATINUM: 3,
    TRIAL: 4,
    COLLEGEPREDICTOR: 5,
});

export const PackageTypeLabel = {
    [PackageType.SILVER]: 'Silver',
    [PackageType.GOLD]: 'Gold',
    [PackageType.PLATINUM]: 'Platinum',
    [PackageType.TRIAL]: 'Trial',
    [PackageType.COLLEGEPREDICTOR]: 'CollegePredictor',
};
